/* eslint-disable no-template-curly-in-string */
import { object, mixed } from 'yup'
import { FILE_SIZE_SMALL, SUPPORTED_FORMATS } from '../constants'

export const createAuthFormSchema = object().shape({
  attachment: mixed()
    .required('Attachment is required')
    .test(
      'fileSize',
      'Upload failed. Max file size is 5MB',
      value => value && value.size <= FILE_SIZE_SMALL
    )
    .test(
      'fileFormat',
      'Unsupported Format. Only files with the "pdf" extensions are allowed',
      value => value && SUPPORTED_FORMATS.includes(value.type)
    ),
})
